import {all, call, fork, put, takeEvery} from 'bukku/shared/SagaService';
import {message} from 'antd';
import actions from './actions';
import {get, post} from 'bukku/shared/ApiService';
import AppActions from '../App/actions';

// Read
export function* readRequest() {
    yield takeEvery(actions.PUBLIC_MINIPOS_ORDER_READ_REQUEST, function* ({ hash, subdomain }) {
        try {
            yield put({type: AppActions.APP_START_PULLING});
            const response = yield call(get, `/public/minipos/orders/${hash}`, {
                subdomain,
            });
            const data = yield response.data;

            // OK
            yield put({
                type: actions.PUBLIC_MINIPOS_ORDER_READ_SUCCESS,
                order: data.order,
                company: data.company,
                contact: data.contact,
                is_order_myinvois_valid: data.is_order_myinvois_valid,
            });

            // yield delay(1000);
            // yield put({
            //     type: actions.PUBLIC_MINIPOS_ORDER_READ_SUCCESS,
            //     order: {
            //         id: 1,
            //         amount: 100,
            //         number: "RECEIPT-2024-0001",
            //         date: "2024-11-28 12:00:59",
            //         payment_method: "Cash",
            //         myinvois_action: "NORMAL", // "NORMAL", "VALIDATE"
            //         is_myinvois_ready: true,
            //         // myinvois_document_status: "VALID",
            //         myinvois_document_public_url: "https://www.google.com/",
            //     },
            //     company: {
            //         id: 2,
            //         key: "8bd111c4ef18d910510178a68638f7f2",
            //         user_id: 2,
            //         subdomain: "marcus",
            //         reg_no: "010313040265",
            //         old_reg_no: "ZZ1234567X",
            //         legal_name: "marcus bukku",
            //         currency_code: "MYR",
            //         currency_symbol: "RM",
            //         country_code: "MY",
            //         is_partner: true,
            //         pm_type: null,
            //         pm_last_four: null,
            //         source: "self",
            //         billing_party: "self",
            //         plan_id: 7,
            //         inventory_system: "perpetual",
            //         partner_manage_users: true,
            //         created_at: "2023-02-25 13:06:35",
            //         updated_at: "2024-07-23 10:36:19",
            //         is_myinvois_ready: true,
            //         is_myinvois_validated: true,
            //         msic_code: "62010",
            //         tax_id_no: "IG50453222070",
            //     },
            //     contact: {
            //         entity_type: "MALAYSIAN_INDIVIDUAL",
            //         legal_name: "marcus general public",
            //         reg_no_type: "NRIC",
            //         reg_no: "010313040265",
            //         tax_id_no: null,
            //         sst_reg_no: null,
            //         phone_no: "60123333221",
            //         email: null,
            //         billing_street: "123",
            //         billing_city: "23",
            //         billing_state: "23",
            //         billing_postcode: null,
            //         billing_country_code: "AD",
            //         is_general_public: false,
            //     },

            // });
        }
        catch (error) {
            yield put({
                type: actions.PUBLIC_MINIPOS_ORDER_READ_ERROR,
                error,
                errorMessage: error.message,
            });
        }
        finally {
            yield put({type: AppActions.APP_STOP_PULLING});
        }
    });
}
export function* readSuccess() {
    yield takeEvery(actions.PUBLIC_MINIPOS_ORDER_READ_SUCCESS, () => {});
}
export function* readError() {
    yield takeEvery(actions.PUBLIC_MINIPOS_ORDER_READ_ERROR, function* ({ error }) {
        // 403 error (not subscribed) is handled by frontend page, don't need to show error message
        if (error.statusCode !== 403 && error.statusCode !== 400)
            yield message.error(error.message);
    });
}

// Request e-invoice
export function* requestEInvoiceRequest() {
    yield takeEvery(actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_REQUEST,
        function* ({request, hash, subdomain}, context) {
            try {
                yield put({ type: AppActions.APP_START_PUSHING });
                const response = yield call(
                    post, `/public/minipos/orders/${hash}/validate?subdomain=${subdomain}`, request, context,
                );
                const data = yield response.data;
                //OK
                yield put({
                    type: actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_SUCCESS,
                    status: data.status,
                    message: data.message,
                });

                // yield put({ type: AppActions.APP_START_PUSHING });

                // yield delay(1000);
                // yield put({
                //     type: actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_SUCCESS,
                //     result: "success",
                //     message: "Invalid TIN provided.",

                // });
            }
            catch (error) {
                yield put({
                    type: actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_ERROR,
                    error,
                });
            }
            finally {
                yield put({ type: AppActions.APP_STOP_PUSHING });
            }
        });
}

export function* requestEInvoiceSuccess() {
    yield takeEvery(actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_SUCCESS, () => {});
}

export function* requestEInvoiceError() {
    yield takeEvery(actions.PUBLIC_MINIPOS_ORDER_REQUEST_E_INVOICE_ERROR, function* ({ error }) {
        yield message.error(error.message);
    });
}

export default function* rootSaga() {
    yield all([
        fork(readRequest),
        fork(readSuccess),
        fork(readError),
        fork(requestEInvoiceRequest),
        fork(requestEInvoiceSuccess),
        fork(requestEInvoiceError),
    ]);
}
